// src/FBConfigs.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";           // ✅ Must have this
import { getFirestore } from "firebase/firestore"; 
import { getStorage } from "firebase/storage";  

const firebaseConfig = {
  apiKey: "AIzaSyDidgNBctoTsmKBsF4cImUzWVGnF517bFQ",
  authDomain: "hack4health-8aec2.firebaseapp.com",
  databaseURL: "https://hack4health-8aec2-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "hack4health-8aec2",
  storageBucket: "hack4health-8aec2.firebasestorage.app",
  messagingSenderId: "778255832142",
  appId: "1:778255832142:web:a6f3057d4a318f3eccdf1f",
  measurementId: "G-7D7X3GDYZF"
};

const app = initializeApp(firebaseConfig);

// ✅ Export auth correctly
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
